export enum CompanySizeEnum {
  justMe = 'Just me',
  size_2_10 = '2-10',
  size_11_19 = '11-19',
  size_20_49 = '20-49',
  size_50_99 = '50-99',
  size_100_249 = '100-249',
  size_250_500 = '250-500',
  size_500_more = '500+',
}

export type ICompanySize = {
  id: CompanySizeEnum
  label: string
}

export const COMPANY_SIZES: ICompanySize[] = [
  { id: CompanySizeEnum.justMe, label: 'Just me' },
  { id: CompanySizeEnum.size_2_10, label: '2 - 10' },
  { id: CompanySizeEnum.size_11_19, label: '11 - 19' },
  { id: CompanySizeEnum.size_20_49, label: '20 - 49' },
  { id: CompanySizeEnum.size_50_99, label: '50 - 99' },
  { id: CompanySizeEnum.size_100_249, label: '100 - 249' },
  { id: CompanySizeEnum.size_250_500, label: '250 - 500' },
  { id: CompanySizeEnum.size_500_more, label: '500+' },
]
